import * as React from 'react';

import EmptyStubContent from '../EmptyStubContent';

const EmptyNote: React.FC = () => {
  return (
    <EmptyStubContent
      title="Выберите заметку"
      text="Выберите заметку из списка слева для просмотра или создайте новую"
    />
  );
};

export default EmptyNote;
